(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function activateAll(steps) {
    steps.forEach((step) => step.classList.add('is-active'));
  }

  function observeTimeline(root) {
    const steps = [...root.querySelectorAll('.la-timeline__step')];
    if (!steps.length) return;

    if (reduceMotion.matches || !('IntersectionObserver' in window)) {
      activateAll(steps);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-active');
          observer.unobserve(entry.target);
        });
      },
      {
        threshold: 0.35,
        rootMargin: '0px 0px -10% 0px',
      }
    );

    steps.forEach((step) => observer.observe(step));
  }

  function init() {
    document.querySelectorAll('.la-timeline').forEach(observeTimeline);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector?.('.la-timeline') || event.target.closest?.('.la-timeline');
    if (root) observeTimeline(root);
  });
})();
